// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__278Xo","header":"ClearentDisclaimer_header__1ciwc","inner":"ClearentDisclaimer_inner__2tHZX"};